"use client";

import React, {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useState,
} from "react";
import { StyleSheet } from "react-native";
import BMView from "../View/BMView";

type PortalMobileContextType = {
  mount: (key: string, children: React.ReactNode) => void;
  update: (key: string, children: React.ReactNode) => void;
  unmount: (key: string) => void;
};

/**
 * @deprecated use `PortalMobile` from `@ctv/shared-core` instead
 */
const PortalMobileContext = createContext<PortalMobileContextType | null>(null);
export const usePortalMobile = () => {
  const ctx = useContext(PortalMobileContext);
  if (!ctx) throw new Error("PortalHost is missing");
  return ctx;
};

export function PortalMobileHost({ children }: PropsWithChildren) {
  const [portals, setPortals] = useState<
    { key: string; children: React.ReactNode }[]
  >([]);

  const mount = useCallback((key: string, children: React.ReactNode) => {
    setPortals((prev) => [...prev, { key, children }]);
  }, []);

  const update = useCallback((key: string, children: React.ReactNode) => {
    setPortals((prev) =>
      prev.map((p) => (p.key === key ? { ...p, children } : p))
    );
  }, []);

  const unmount = useCallback((key: string) => {
    setPortals((prev) => prev.filter((p) => p.key !== key));
  }, []);

  const value = React.useMemo(
    () => ({ mount, update, unmount }),
    [mount, update, unmount]
  );

  return (
    <PortalMobileContext.Provider value={value}>
      <BMView flex={1}>
        {children}
        {portals.map(({ key, children }) => (
          <BMView key={key} style={StyleSheet.absoluteFill}>
            {children}
          </BMView>
        ))}
      </BMView>
    </PortalMobileContext.Provider>
  );
}
